import { CONFIRM_ACTION_NOTIFICATION, CONTRAINTE_DELETE_NOTIFICATION, CONTRAINTE_NOTIFICATION, DUPLICATION_NOTIFICATION, RESET_CONFIRM_ACTIONS } from "../constants/actionTypes.js"

// Action creator
export const contrainteNotification = (idObject, typeObject) => async (dispatch) => {

    try{
        dispatch({ type: CONTRAINTE_NOTIFICATION, payload: {idObject, typeObject}})

    } catch(error){
        console.log(error.message)
    } 
}

export const deleteContrainteNotification = (idObject) => (dispatch) => {
    try{
        dispatch({ type: CONTRAINTE_DELETE_NOTIFICATION, payload: idObject})
    } catch(error){
        console.log(error.message)
    } 
}

// Action creator
export const duplicationNotification = (objectToCreate, duplicates, typeObject) => async (dispatch) => {

    try{
        dispatch({ type: DUPLICATION_NOTIFICATION, payload: {objectToCreate, duplicates, typeObject}})

    } catch(error){
        console.log(error.message)
    } 
}

// Action creator
export const confirmActionNotification = (label, action) => async (dispatch) => {

    try{
        dispatch({ type: CONFIRM_ACTION_NOTIFICATION, payload: {label, action}})

    } catch(error){
        console.log(error.message)
    } 
}


export const resetConfirmActions = () => (dispatch) => {
  try {
    dispatch({ type: RESET_CONFIRM_ACTIONS });
  } catch (error) {
    console.log(error.message);
  }
};